import { UserClaims } from '@services/business/identity/entities';
import { ApiInterface, EmptyObject } from '@stetamalo/cloud-platform/catalog/api';
import { ApiConfig } from 'services/support/utils/types/api-config';
import { CashRegisterBalance } from '../../entities';

export type Interface = ApiInterface<{
  response: CashRegisterBalance;
  pathParams: EmptyObject;
  body: EmptyObject;
  claims: UserClaims;
  queryParams: EmptyObject;
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-get-cash-balance',
  method: 'GET',
  basePath: 'cash-register',
  path: '/balance',
  tablePermission: 'readWrite',
  scope: 'RECEPTIONIST',
};
